import { useEffect, useState } from "react";
import { useHostPortalContext } from "../../context/HostPortalContext";
import { useAlertContext } from "../../context/AlertContext";
import corporateAccountService from "../../services/corporateAccountService";
import DashboardLayout from "../../components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../components/Navbars/DashboardNavbar";
import Footer from "../../components/Footer";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { formatDate } from "../../Utils";
//import ProfilePic from "../../controls/ProfilePic";

import { CorporateHostRatingsList } from "../../models/corporateHostRatingsListModel";
import { StarIcon } from "../../components/Icons/Index";
import { useParams } from "react-router-dom";
import LoadingSpinner from "controls/LoadingSpinner";

const CorporateHostRatings = () => {
  const { id } = useParams<{ id: any }>();
  const { host } = useHostPortalContext();
  const { setAlert } = useAlertContext();

  const [loading, setLoading] = useState(true);
  const [ratings, setRatings] = useState<CorporateHostRatingsList[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadRatings();
  }, [host]);

      const loadRatings = async () => {
      setLoading(true);
      try {
        const data = await corporateAccountService.getHostRatings(host ? host.id : id);
        if (data) {
          setRatings(data);
        } else {
          setAlert("error", "Unable to load ratings");
        }
      } catch (err: any) {
        console.error(err);
        setAlert("error", "Error loading ratings");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      loadRatings();
    }, [id]);

  const filteredRatings = ratings.filter(
    (item) =>
      `${item.firstName} ${item.lastName}`.toLowerCase().includes(search.toLowerCase())
  );

  const renderRatingCard = (item: CorporateHostRatingsList) => (
    <Card
      key={item.id}
      sx={{
        flex: "1 1 300px",
        margin: 1,
        padding: 2,
        boxSizing: "border-box",
        minWidth: 250,
        cursor: "default",
      }}
    >
      <MDBox display="flex" alignItems="center" mb={1}>
            <img
                src={item.profilePic}
                alt={`${item.firstName} ${item.lastName}`}
                width={50}
                height={50}
                style={{ borderRadius: "50%", objectFit: "cover" }}
                />
        <MDBox ml={1}>
          <MDTypography fontWeight="medium" color="text">
            {item.firstName} {item.lastName}
          </MDTypography>
          <MDTypography variant="caption" color="text">
            {formatDate(item.created, true)}
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox display="flex" mb={1}>
        {Array.from({ length: item.rating }).map((_, i) => (
          <StarIcon key={i} />
        ))}
      </MDBox>

      {item.note && (
        <MDTypography color="text" fontSize={14} mt={0.5}>
          “{item.note}”
        </MDTypography>
      )}
    </Card>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3} px={2}>
        <MDTypography variant="h5" fontWeight="bold">
          {host?.name ?? "Location"} Ratings
        </MDTypography>
        <MDTypography variant="button" color="text" mb={2}>
          All recent user feedback and ratings for this location.
        </MDTypography>

        {loading ? (
          <LoadingSpinner title="Loading Ratings..." />
        ) : filteredRatings.length === 0 ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" mt={4}>
            <MDTypography>No ratings for this location.</MDTypography>
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            {filteredRatings.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                {renderRatingCard(item)}
              </Grid>
            ))}
          </Grid>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default CorporateHostRatings;
